import React from 'react';
import './employer-list.css';

const EmployerList = ({ employers }) => {
  if (!employers || employers.length === 0) {
    return <p>No shared employers found.</p>;
  }

  return (
    <div className="employer-list">
      <h4>Shared Employers</h4>
      <ul>
        {employers.map(employer => (
          <li key={employer.id}>
            <span className="employer-name">{employer.name}</span>
            <span className="employer-type">{employer.type}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default EmployerList;
